var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter",on:{"click":function($event){return _vm.OpenTableFilter($event)}}},[_c('div',{staticClass:"fas fa-filter"})])}
var staticRenderFns = []

export { render, staticRenderFns }